var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center d-flex flex-wrap",class:{ loader: true, fadeout: !_vm.isLoading }},[_c('b-img',{staticClass:"align-self-center img-loader",attrs:{"alt":"Vue logo","src":require('@/assets/loading.gif')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }